<template>
  <v-col align="center">
    <v-container>
      <v-card width="1000">
        <v-card-title>
          <div class="mt-6 mb-3 page-header">HawkSoft Text Messaging</div>
        </v-card-title>

        <v-card-text style="color: #4F4F4F">
          <div class="my-2 text-left">
            Thank you for using HawkSoft Text Messaging.
          </div>
          <div class="my-2 text-left">
            Please close this window and restart CMS to remove HawkSoft Text Messaging from CMS.
          </div>
          <div
            v-if="textingChargeFeatureSwitchOn"
            class="my-2 text-left"
          >
            Changes to your HawkSoft Subscription amount will be reflected on your next invoice.
          </div>
        </v-card-text>

        <v-card-actions>
          <div class="pa-1">
            <v-btn @click="$router.push('/marketplace')">Return to Marketplace</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'TextingCancelled',
  computed: {
    ...mapState([
      'featureSwitches'
    ]),
    textingChargeFeatureSwitchOn () {
      return this.featureSwitches.TextingProductStatusToggle != null && this.featureSwitches.TextingProductStatusToggle;
    }
  },
  async created () {
    this.getFeatureSwitches();
  },
  methods: {
    ...mapActions([
      'getFeatureSwitches'
    ])
  }
};
</script>
